import { createContext, useState, useContext } from "react";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
    const [notification, setNotification] = useState(null);

    // const showNotification = (message, type) => {
    //     setNotification({ message, type });
    //
    //     // Auto-hide after 3 seconds
    //     setTimeout(() => {
    //         setNotification(null);
    //     }, 3000);
    // };


    const showNotification = (msg, type) => {
        const message = typeof msg === "object" ? msg.message : msg;
        const notificationType = typeof msg === "object" ? msg.type : type;
        setNotification({ message, type: notificationType });
        setTimeout(() => setNotification(null), 3000);
    };


    return (
        <NotificationContext.Provider value={{ showNotification }}>
            {children}

            {notification && (
                <div
                    className={`fixed top-4 right-4 px-4 py-3 rounded-lg shadow-md text-white flex items-center justify-between max-w-sm 
            ${notification.type === "success" ? "bg-green-500" : "bg-red-500"}`}
                >
                        <span>{notification.message}</span>
                    <button className="ml-4 text-lg font-bold" onClick={() => setNotification(null)}>
                        ✖
                    </button>
                </div>
            )}
        </NotificationContext.Provider>
    );
};

// Hook for easy usage
export const useNotification = () => useContext(NotificationContext);
